import { BookOpen } from "lucide-react";
import { tr, LESSON_STATUS_LABEL, LESSON_TYPE_LABEL, fmtLessonRange } from "@/lib/labels";

const MOD_BADGE = { PRESENTIAL: "doxa-badge-neutral", ONLINE: "doxa-badge-success", HYBRID: "doxa-badge-warning" };

export function PortalLoading() {
  return <div className="py-16 text-center text-sm text-[#6B655E]">Carregando…</div>;
}

export function PortalEmpty({ icon: Icon = BookOpen, title, description }) {
  return <div className="doxa-card p-8 text-center"><Icon className="w-8 h-8 mx-auto text-[#B8AEA2]" /><p className="font-display font-bold mt-3">{title}</p>{description && <p className="text-sm text-[#6B655E] mt-1 max-w-md mx-auto">{description}</p>}</div>;
}

export function PortalPageHeader({ eyebrow, title, description, action }) {
  return <div className="flex items-start justify-between gap-4 mb-5"><div>{eyebrow && <p className="text-[11px] uppercase tracking-[0.14em] font-semibold text-[#F75A1B]">{eyebrow}</p>}<h1 className="font-display text-2xl sm:text-3xl font-bold mt-1">{title}</h1>{description && <p className="text-sm text-[#6B655E] mt-1 max-w-2xl">{description}</p>}</div>{action}</div>;
}

export function ModalityBadge({ type }) {
  return <span className={`doxa-badge ${MOD_BADGE[type] || "doxa-badge-neutral"}`}>{tr(LESSON_TYPE_LABEL, type || "PRESENTIAL")}</span>;
}

export function LessonMeta({ lesson }) {
  return <div className="flex flex-wrap items-center gap-2 mt-2"><span className={`doxa-badge ${lesson.status === "OPEN" ? "doxa-badge-success" : "doxa-badge-neutral"}`}>{tr(LESSON_STATUS_LABEL, lesson.status)}</span><ModalityBadge type={lesson.lesson_type} /><span className="text-xs text-[#6B655E]">{fmtLessonRange(lesson.lesson_date, lesson.start_time, lesson.end_time)}</span></div>;
}
